<template>
  <div class="card">

    <div class="card-header header-elements-inline" >
      <h5 class="card-title">Item Information</h5>
      <div class="header-elements">
        <div class="list-icons">

          <a class="list-icons-item" data-action="reload" @click="loadGroup"></a>
          <a class="list-icons-item" data-action="remove" @click="closeWindow"></a>
        </div>
      </div>
    </div>

    <div class="card-body">
      <form action="#">

        <div class="form-group row">
          <label class="col-lg-2 col-form-label">Group:</label>
          <div class="col-lg-10">
<!--            v-model="item.group.code"-->
            <select class="form-control form-control-select2" autofocus v-if="item" v-model="item.group.code"  >
              <option v-for="group in groups" v-bind:value="group.code">
                {{ group.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-lg-2 col-form-label">Name:</label>
          <div class="col-lg-10">
            <input type="text" class="form-control" placeholder="Enter Item Name here..." maxlength="100" v-if="item" v-model="item.name">
          </div>
        </div>

        <div class="form-group row">
          <label class="col-lg-2 col-form-label">Print Name:</label>
          <div class="col-lg-10">
            <input type="text" class="form-control" placeholder="Enter Item Print Name here..." maxlength="100" v-if="item" v-model="item.pname">
          </div>
        </div>

        <!--<div class="form-group row">-->
          <!--<label class="col-lg-2 col-form-label">Category:</label>-->
          <!--<div class="col-lg-4">-->
            <!--<select class="form-control form-control-select2" v-if="item" v-model="item.category.code">-->
              <!--<option v-for="category in categories" v-bind:value="category.code">-->
                <!--{{ category.name }}-->
              <!--</option>-->
            <!--</select>-->
          <!--</div>-->

          <!--<label class="col-lg-1 col-form-label">Brand:</label>-->
          <!--<div class="col-lg-5">-->
            <!--<select class="form-control form-control-select2" v-if="item" v-model="item.brand.code">-->
              <!--<option v-for="brand in brands" v-bind:value="brand.code">-->
                <!--{{ brand.name }}-->
              <!--</option>-->
            <!--</select>-->
          <!--</div>-->
        <!--</div>-->

        <div class="form-group row">
          <label class="col-lg-2 col-form-label">Unit of measure:</label>
          <div class="col-lg-2">
            <select class="form-control form-control-select2" v-if="item" >
              <option value=1>Nos</option>
              <option value=2>Kgs</option>
              <option value=4>Ltr</option>
            </select>
          </div>

          <label class="col-lg-2 col-form-label">Min Qty:</label>
          <div class="col-lg-2">
            <input type="number" class="form-control text-right" placeholder="min stock qty" min="0" v-if="item" v-model="item.min_qty">
          </div>

          <label class="col-lg-2 col-form-label">Max Qty:</label>
          <div class="col-lg-2">
            <input type="number" class="form-control text-right" placeholder="max stock qty" min="0" v-if="item" v-model="item.max_qty">
          </div>
        </div>

        <div class="form-group row">
          <label class="col-lg-2 col-form-label">Selling Price:</label>
          <div class="col-lg-2">
            <input type="number" class="form-control text-right" placeholder="Selling Price" min="0" v-if="item" v-model="item.salerate">
          </div>

<!--          <label class="col-lg-2 col-form-label">Min Qty:</label>-->
<!--          <div class="col-lg-2">-->
<!--            <input type="number" class="form-control text-right" placeholder="min stock qty" min="0" v-if="item" v-model="item.min_qty">-->
<!--          </div>-->

<!--          <label class="col-lg-2 col-form-label">Max Qty:</label>-->
<!--          <div class="col-lg-2">-->
<!--            <input type="number" class="form-control text-right" placeholder="max stock qty" min="0" v-if="item" v-model="item.max_qty">-->
<!--          </div>-->
        </div>

<!--        <div class="form-group row">-->
<!--          <label class="col-lg-2 col-form-label">Ledger: Purchase</label>-->
<!--          <div class="col-lg-4">-->
<!--            <select class="form-control form-control-select2" >-->
<!--              <option value="1">-</option>-->
<!--              <option v-for="ledger in purchledgers" v-bind:value="ledger.code">-->
<!--                {{ ledger.name }}-->
<!--              </option>-->
<!--            </select>-->
<!--          </div>-->

<!--          <label class="col-lg-1 col-form-label">Sale </label>-->
<!--          <div class="col-lg-5">-->
<!--            <select class="form-control form-control-select2" >-->
<!--              <option value="1">-</option>-->
<!--              <option v-for="ledger in saleledgers" v-bind:value="ledger.code">-->
<!--                {{ ledger.name }}-->
<!--              </option>-->
<!--            </select>-->
<!--          </div>-->
<!--        </div>-->

      </form>
    </div>

    <div class="card-footer">
      <div class="text-right" >
        <button type="button" class="btn btn-primary" @click="saveDocument" >Save<i class="icon-paperplane ml-2"></i></button>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '@/store/store.js'
import { userService } from '@/store/auth-header.js'
export default {
  name: 'ItemForm',
  store,
  data () {
    return {
      item: JSON.parse('{"_id":"","code":0,"name":"","salerate":0,"group":{"_id":"","code":0,"name":"","pname":"","hsn":"","taxrate":0,"nature":1,"itc":0},"min_qty":0,"max_qty":0,"unit":1}'),
      groups: [],
    }
  },
  props: {
    myitem: {
      type: Object,
      required: true,
      default: JSON.parse('{"_id":"","code":0,"name":"","salerate":0,"group":{"_id":"","code":0,"name":"","pname":"","hsn":"","taxrate":0,"nature":1,"itc":0},"min_qty":0,"max_qty":0,"unit":1}')
    }
  },
  beforeMount () {
    this.item = this.myitem;
  },
  component: {

  },
  created () {
    this.$data.item = JSON.parse('{"_id":"","code":0,"name":"","salerate":0,"group":{"_id":"","code":0,"name":"","pname":"","hsn":"","taxrate":0,"nature":1,"itc":0},"min_qty":0,"max_qty":0,"unit":1}')
  },
  mounted () {
    let self = this;
    // $('.form-control-select2').select2()

    self.loadGroup();
  },
  methods: {
    closeWindow () {
      this.$emit('item_window_closed');
    },
    clear () {
      this.$data.item = JSON.parse('{"_id":"","code":0,"name":"","salerate":0,"group":{"_id":"","code":0,"name":"","pname":"","hsn":"","taxrate":0,"nature":1,"itc":0},"min_qty":0,"max_qty":0,"unit":1}')
    },
    loadGroup () {
      let self = this;

      const requestOptions = {
        method: 'GET',
        mode: 'cors',
        headers: userService.authHeader()
      }

      fetch(`${process.env.VUE_APP_ROOT_API}api/v1/xpos/itemgroup/after/1/`, requestOptions).then(userService.handleResponse).then(function (resp) {
        if (resp.accepted) {
          self.$data.groups = resp.data
        } else {
          swal({ title: 'Oops!', text: resp.msg, type: 'error' })
        }
      }).catch(function (err) {
        swal({ title: 'Oh noes!', text: err.toString(), type: 'error' })
      })
    },
    saveDocument () {
      const self = this;

      self.$data.item.group.code = parseInt(self.$data.item.group.code);
      self.$data.item.min_qty = parseFloat(self.$data.item.min_qty);
      self.$data.item.max_qty = parseFloat(self.$data.item.max_qty);
      self.$data.item.salerate = parseFloat(self.$data.item.salerate);

      if (self.$data.item.name.trim().length < 1) {
        alert('Invalid Name')
        return
      }

      const requestOptions = {
        method: (self.$data.item.code == 0 ? 'POST' : 'PUT'),
        mode: 'cors',
        headers: userService.authHeader(),
        body: JSON.stringify(self.$data.item)
      }

      fetch(`${process.env.VUE_APP_ROOT_API}api/v1/xpos/item/`, requestOptions).then(userService.handleResponse).then(function (resp) {
        if (resp.accepted) {

          swal({ title: 'Success!', text: resp.msg, type: 'success' });
          self.item = JSON.parse('{"_id":"","code":0,"name":"","salerate":0,"group":{"_id":"","code":0,"name":"","pname":"","hsn":"","taxrate":0,"nature":1,"itc":0},"min_qty":0,"max_qty":0,"unit":1}');
          self.$emit('item_saved', resp.data);

        } else {
          swal({ title: 'Oops!', text: resp.msg, type: 'error' })
        }
      }).catch(function (err) {
        swal({ title: 'Oh noes!', text: err.toString(), type: 'error' });
      })
    }
  }
}
</script>

<style scoped>

</style>
